import AzureExtractFeed from './AzureExtractFeed'

export default function SlotAnalysisFeed() {
  return <AzureExtractFeed feedId="slot-analysis" />
}
